import {createWebHistory, createRouter} from 'vue-router'
import HomePage from './components/Home.vue';
import LoGin from "@/components/Login.vue";
import CreateEnquiry from "@/components/CreateEnquiry.vue";
import ConfirmedOrders from "@/components/ConfirmedOrders.vue";
import WarrantyGenerator from "@/components/WarrantyGenerator.vue";
import ViewOrderWarranties from "@/components/ViewOrderWarranties.vue";

const routes = [
    {
        name: 'Home',
        path: '/home',
        component: HomePage
    },
    {
        name: 'Login',
        path: '/',
        component: LoGin
    },
    {
        name: 'CreateEnquiry',
        path: '/createenquiry',
        component: CreateEnquiry
    },
    {
        name: 'ConfirmedOrders',
        path: '/confirmedorders',
        component: ConfirmedOrders
    },
    {
        name: 'WarrantyGenerator',
        path: '/WarrantyGenerator',
        component: WarrantyGenerator
    },
    {
        name: 'ViewOrderWarranties',    // CORRECT: The name used by your button's <router-link>
        path: '/view-warranties/:sr', // we are opening url based on 'sr' so this way we are sending our sr value
        component: ViewOrderWarranties,
        props: true
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router;